'use client';
import React from 'react';
import Link from 'next/link';
import SubHeader from './sub-header';
import { useServerAuth } from '@/auth';

const Desktop: React.FC<{ showLinks: boolean }> = ({ showLinks }) => {
  const { hydrated, user } = useServerAuth();

  const isLogged = !!user && hydrated;
  return (
    <div className="hidden lg:block">
      <header className="bg-paper z-10">
        <div className="max-w-[1600px] mx-auto flex justify-between items-center px-4 md:px-8 lg:px-10 xl:px-[80px] py-6 gap-x-4 w-full h-[90px]">
          <Link href={isLogged ? '/my-home' : '/'}>
            <img
              loading="lazy"
              src="/assets/images/logotipo-white.svg"
              alt="Vibly"
              className={`h-[42px] w-auto ${!hydrated ? 'animate-pulse' : ''}`} // Apply pulse effect when hydrated is false
            />
          </Link>
          <SubHeader showLinks={showLinks} />
        </div>
      </header>
    </div>
  );
};

export default Desktop;
